import { useEffect, useState } from "react";
import { getRefiTodoList } from "./DocuMateRefiService";
import { getRefiGridColumns } from "./RefiTodoListService";
import { FallbackComponent } from "../../shared/components/FallbackComponent";
import { ErrorBoundary} from 'react-error-boundary';
import Grid from "../../components/components/Grid/Grid";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ConfirmModal } from "../../shared/components/confirmModal";
import * as documateLabel from '../shared/util/docuMateLabel';
import { Alert, Card, Container, Row } from "react-bootstrap";
import { Column } from "../../components";
import { RefiTodoListDto } from "../model/RefiiTodoListDto";
import { updateRefiDocumentStatus } from "../services/DocuMateAPI";
import { useSelector } from "react-redux";
import { CommonUtility } from "../../Services/CommonUtility";
import * as docuMateConstant from '../shared/util/docuMateConstant';

const RefiTodoList = () => {
    const [todoList, setTodoList] = useState<RefiTodoListDto[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [modalBody, setModalBody] = useState(null);
    const [currentId, setCurrentId] = useState('');
    const [LIMIT] = useState(10);
    const [currLocked, setCurrLocked] = useState(0);
    const [lockedDocs, setLockedDocs] = useState<RefiTodoListDto[]>([]);
    const [InProgressStatus] = useState('InProgress');
    const userDetails = useSelector((state: any) => state.userContextSlice);
    const [warningText, setWarningText] = useState('');
    const [isViewOnly, setIsViewOnly] = useState(false);

    const loadTodoList = () => {
        setIsLoading(true);
        getRefiTodoList().then((data) => {
            setTodoList(data);
            setCurrLocked(data.filter((doc) => doc.isLocked).length);
            setLockedDocs(data.filter((doc) => doc.isLocked));
            setIsLoading(false);
        });
    };

    useEffect(() => {
        loadTodoList();
    }, []);

    const toggleLockDocument = (id: string, isLocked: boolean) => {
        if(currLocked >= LIMIT && !isLocked) {
            toast.warn('You have reached the maximum number of documents to be reviewed for Refi Automated Process.');
            return;
        }
        todoList.find((doc) => doc.refiRequestId === id).isLocked = !isLocked;
        setCurrLocked(todoList.filter((doc) => doc.isLocked).length);
        setLockedDocs(fetchLockedDocuments());
    }

    const fetchLockedDocuments = () => {
        const lockedDocuments = todoList.filter((doc) => doc.isLocked);
        return lockedDocuments;
    };

    const handleClosePopup = (warningText: string) => {
        setShowConfirmModal(false);
        if (warningText !== '') {
            toast.warning(warningText,
                {
                    position: toast.POSITION.TOP_RIGHT,
                });

            setWarningText('');
        }
    }

    const handleConfirmModal = () => {
        if(currentId) {
            history.push({
                pathname: `/documate-refi/processing`,
                state: { id: currentId, fileName: todoList.find((doc) => doc.refiRequestId === currentId)?.fileName, lockedDocs: lockedDocs, viewOnly: isViewOnly }
            });
        }
        setShowConfirmModal(false);
      }

      const getConfirmModalBody = (userName, dateTime) => (
        <>   
        The Document is currently being approved by user <strong>{userName}</strong>.<br /><br />Would you like to open as <strong>VIEW ONLY</strong>?
        </>
      );

      const getUserName = user => {
        return `${user.firstName} ${user.lastName}`;
      };

    // Marks the document InProgress for this user. The API returns false when another user
    // already holds it or it has been processed; so reload list too.
    const claimDocument = async (id: string) => {
        const res = await updateRefiDocumentStatus(id, InProgressStatus);
        if (res.data === false) {
            toast.warning('This document is no longer available. It may have been opened or processed by another user.');
            loadTodoList();
            return false;
        }
        return true;
    };

    const handleDocumentClick = async (id: string) => {
        let currentDocument = todoList.find((doc) => doc.refiRequestId === id);
        if( currentDocument && currentDocument?.status === InProgressStatus && currentDocument?.updatedBy !== getUserName(userDetails.userContext)) {
            setModalBody(getConfirmModalBody(currentDocument?.updatedBy, CommonUtility.formateDateTime(currentDocument?.updateDateTime,  CommonUtility.DateTimeFormatWithSecond)));
            setCurrentId(id);
            setIsViewOnly(true);
            setShowConfirmModal(true);
        }
        else {
            try {
                // if clicked document is being worked by current user
                if (currentDocument && currentDocument?.status === InProgressStatus && currentDocument?.updatedBy == getUserName(userDetails.userContext)) {
                    if (!(await claimDocument(id))) return;
                    history.push({
                        pathname: `/documate-refi/processing`,
                        state: { id: id, fileName: todoList.find((doc) => doc.refiRequestId === id)?.fileName, lockedDocs: lockedDocs }
                    });
                }
                // if user is working on any other document
                else if ((todoList.filter((doc) => doc.updatedBy === getUserName(userDetails.userContext) && doc.status === InProgressStatus)).length > 0) {
                    console.log((todoList.filter((doc) => doc.updatedBy === getUserName(userDetails.userContext) && doc.status === InProgressStatus)).length);
                    let documentInProgress = (todoList.filter((doc) => doc.updatedBy === getUserName(userDetails.userContext) && doc.status === InProgressStatus))[0];

                    const modalBody = (
                        <>
                            You are currently approving <strong> {documentInProgress.fileName} </strong>.  You must complete current indexing before opening another file.  Would you like to finish approving current document?
                        </>
                    );
                    setModalBody(modalBody);
                    setCurrentId(documentInProgress.refiRequestId);
                    setIsViewOnly(false);
                    setWarningText(docuMateConstant.Warning_OnClickOfPopup_No);
                    setShowConfirmModal(true);
                }
                // clicking on document when not working other any document
                else {
                    if (!(await claimDocument(id))) return;
                    history.push({
                        pathname: `/documate-refi/processing`,
                        state: { id: id, fileName: todoList.find((doc) => doc.refiRequestId === id)?.fileName, lockedDocs: lockedDocs }
                    });
                }

                //   await updateRefiDocumentStatus(id, InProgressStatus);
            } catch (error) {
                toast.error('Error updating document status. Please try again later.');
                return;
            }
    }
    }

    const gridColumns = getRefiGridColumns(handleDocumentClick, toggleLockDocument);
    
    return (
        <>
            <ErrorBoundary FallbackComponent={FallbackComponent}>
                
                <Container fluid>
                    <Row>
                        <Column lg={12} md={12}>
                        <Alert variant="info" className="p-2">
                    {/* Selected {currLocked} of {LIMIT} documents of {todoList.length} records */}
                    Total count: {todoList.length} records
                </Alert>
                            <Card>
                                <div className='documate-todoList-main-div'>
                                    {!isLoading &&
                                        <Grid
                                            data={todoList}
                                            showFilters={true}
                                            id={'refiToDoListGrid'}
                                            retainGridState={false}
                                            defaultPageSize={10}
                                            columns={gridColumns}
                                            hiddenColumns={['selection']}
                                            sortDefault={[]}
                                            grdTableContainerClass='p-0 table-container-campaign'
                                            grdTabelClass='table-striped table-hover table-sm'
                                            zindexHeader={10000} />
                                    }
                                </div>
                            </Card>
                            <ConfirmModal
                                modaltitle={documateLabel.CONFIRM}
                                showConfirmation={showConfirmModal}
                                setConfirmation={(isModalOpen) => setShowConfirmModal(isModalOpen)}
                                body={modalBody}
                                closeButtonClick={() => handleClosePopup(warningText)}
                                successButtonClick={() => handleConfirmModal()}
                                closeButtonLabel={documateLabel.CONFIRM_NO.toUpperCase()}
                                successButtonLabel={documateLabel.CONFIRM_YES.toUpperCase()}
                            />

                        </Column>
                    </Row>
                </Container>
            </ErrorBoundary>
        </>
    );
}
export default RefiTodoList;